import Swiper, { Navigation, Lazy, Pagination, EffectFade } from "swiper";
import GoogleMap from "../utils/map";

const Home = {
  init() {

    // Home.renderMap();
    Home.historySlider();
    Home.partnersSlider();
    Home.teamSlider();
    Home.esgSlider();
    Home.brands();
  },

  // renderMap() {
  //   const mapEl = $("#map-wrap");

  //   if (!mapEl.length) {
  //     return;
  //   }

  //   const data = {
  //     lat: mapEl.data("lat"),
  //     lng: mapEl.data("lng"),
  //     zoom: mapEl.data("zoom"),
  //   };

  //   GoogleMap.create(data, mapEl);
  // },

  brands() {
    const brandsList = document.querySelector(".brands__list");

    if (!brandsList) return;

    const brands = brandsList.querySelectorAll(".brand-item");
    const brandCount = brands.length;

    if (brandCount === 4) {
      brandsList.classList.add("four-brands");
    }
  },



  historySlider() {
    const historyEl = $(".history");
    if (!historyEl.length) {
      return;
    }

    const navPrev = historyEl.find(".swiper-button--prev");
    const navNext = historyEl.find(".swiper-button--next");

    if (historyEl.length) {
      new Swiper(historyEl.find(".history__slider")[0], {
        modules: [Navigation],
        slidesPerView: "auto",
        navigation: {
          prevEl: navPrev[0],
          nextEl: navNext[0],
        },

      })
    }
  },

  partnersSlider() {
    const partnersEl = $(".partners");
    if (!partnersEl.length) {
      return;
    }

    const navPrev = partnersEl.find(".swiper-button--prev");
    const navNext = partnersEl.find(".swiper-button--next");


    if (partnersEl.length) {
      new Swiper(partnersEl.find(".partners__logos-slider")[0], {
        modules: [Navigation],
        slidesPerView: "auto",
        spaceBetween: 5,
        navigation: {
          prevEl: navPrev[0],
          nextEl: navNext[0],
        },
        breakpoints: {
          600: {
            spaceBetween: 10,
          }
        }

      })
    }
  },

  teamSlider() {
    const teamEl = $(".team");
    if (!teamEl.length) {
      return;
    }

    const navPrev = teamEl.find(".swiper-button--prev");
    const navNext = teamEl.find(".swiper-button--next");

    function updateNavigation() {
      let slideCount = $(".team .swiper-slide").length;
      let sliderWidth = $(".team__slider")[0].offsetWidth;
      let slidesWidth = slideCount * 320;

      let tooFewSlides = sliderWidth > slidesWidth;

      if (!tooFewSlides) {
        navNext.removeClass("hidden");
        navPrev.removeClass("hidden");
      } else {
        navNext.addClass("hidden");
        navPrev.addClass("hidden");
      }
    }

    updateNavigation();
    // Check on window resize
    $(window).on('resize', updateNavigation);

    new Swiper(teamEl.find(".team__slider")[0], {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 20,

      navigation: {
        prevEl: navPrev[0],
        nextEl: navNext[0],
      },
      breakpoints: {
        600: {
          slidesPerView: "auto",
        }
      }
    });
  },


  esgSlider() {
    const esgEl = $(".esg");
    if (!esgEl.length) {
      return;
    }

    const navPrev = esgEl.find(".swiper-button--prev");
    const navNext = esgEl.find(".swiper-button--next");


    if (esgEl.length) {
      new Swiper(esgEl.find(".esg__slider")[0], {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 20,

        navigation: {
          prevEl: navPrev[0],
          nextEl: navNext[0],
        },
        breakpoints: {
          600: {
            slidesPerView: "auto",
            autoHeight: false,
          }
        }

      })
    }
  }
};

export default Home;
